import React, { useContext } from "react";
import { Button, Input, Select, Spin } from "antd";
import SpectrumContext from "./SpectrumContext";
import "./SpectrumForm.scss";

export default function FormFrequency() {
  const {
    inputsState,
    onChangeInputsState,
    loadUcodeList,
    isLoadingFreq,
  } = useContext(SpectrumContext);
  const { bgn_frq_hz, end_frq_hz, frq_hz } = inputsState;

  return (
    <div className="SpectrumForm">
      <div className="field">
        <label className="ant-form-item-label">시작 주파수</label>
        <Input
          type={"number"}
          name={"bgn_frq_hz"}
          placeholder={"시작 주파수"}
          value={bgn_frq_hz}
          onChange={onChangeInputsState}
          style={{ width: 200 }}
        />
      </div>
      <div className="field">
        <label className="ant-form-item-label">종료 주파수</label>
        <Input
          type={"number"}
          name={"end_frq_hz"}
          placeholder={"종료 주파수"}
          value={end_frq_hz}
          onChange={onChangeInputsState}
          style={{ width: 200 }}
        />
      </div>
      <div className="field2">
        <label className="ant-form-item-label">단위</label>
        <Select
          style={{ width: 80 }}
          name={"frq_hz"}
          value={frq_hz}
          onChange={(value) =>
            onChangeInputsState({ target: { name: "frq_hz", value } })
          }
        >
          <Select.Option value={1000}>kHz</Select.Option>
          <Select.Option value={1000000}>MHz</Select.Option>
          <Select.Option value={1000000000}>GHz</Select.Option>
        </Select>

        <Button
          type={"primary"}
          onClick={loadUcodeList}
          disabled={isLoadingFreq}
          style={{ width: "110px", marginLeft: "10px"  }}
        >
          {isLoadingFreq && <Spin spinning={true} style={{ marginRight: 8 }} />}
          설정
        </Button>
      </div>
    </div>
  );
}
